import React from 'react';
import { View, StyleSheet } from 'react-native';
import { ShowMoreText } from '@/components/common/ShowMoreText';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface BulletinDescriptionProps {
  text: string;
  expanded: boolean;
  onToggle: () => void;
}

export const BulletinDescription: React.FC<BulletinDescriptionProps> = ({ text, expanded, onToggle }) => {
  return (
    <View style={styles.descriptionContainer}>
      <ShowMoreText
        text={text}
        expanded={expanded}
        onToggle={onToggle}
        textStyle={styles.description}
        linkStyle={styles.showMoreText}
        rightIcon={(
          <View style={[styles.showMoreIcon, expanded && styles.showMoreIconRotated]}>
            <SVG_COMPONENTS.CHEVRON_DOWN width={16} height={16} color={ADMIN_COLORS.PRIMARY} />
          </View>
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  descriptionContainer: {
    marginBottom: 8,
  },
  description: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    lineHeight: 20,
    marginBottom: 4,
  },
  showMoreText: {
    fontSize: 14,
    color: ADMIN_COLORS.PRIMARY,
    marginRight: 4,
  },
  showMoreIcon: {
    transform: [{ rotate: '0deg' }],
  },
  showMoreIconRotated: {
    transform: [{ rotate: '180deg' }],
  },
});

export default BulletinDescription;


